import { DoqType, ResponsiveDoqWithSpeechBubble } from '@ardoq/doq';
import { EmptyStatesDoqContainer } from '@ardoq/graph';
import { SecondaryButton } from '@ardoq/button';
import { t, type I18nLocale } from '@ardoq/i18n';
import { i18nLocale$ } from 'streams/i18nLocale$';
import { connect } from '@ardoq/rxbeach';
import { map } from 'rxjs';
import { OnButtonClick } from './EmptyStateLayout/types';

type OnlyZeroValuesInBubbleSizeFieldDoqProps = {
  doqType: DoqType;
  onChangeBubbleSizeField: OnButtonClick;
  onShowSizeZeroBubbles: VoidFunction;
  i18nLocale: I18nLocale;
};

const OnlyZeroValuesInBubbleSizeFieldDoqBase = ({
  doqType,
  onChangeBubbleSizeField,
  onShowSizeZeroBubbles,
  i18nLocale,
}: OnlyZeroValuesInBubbleSizeFieldDoqProps) => {
  return (
    <EmptyStatesDoqContainer>
      <ResponsiveDoqWithSpeechBubble
        doqType={doqType}
        title={t(
          i18nLocale,
          'tabview:graphViews.emptyState.onlyZeroValuesInBubbleSize.title',
          'There is no data to show'
        )}
        message={t(
          i18nLocale,
          'tabview:graphViews.emptyState.onlyZeroValuesInBubbleSize.message',
          'The context workspace or component has only 0 in the Bubble size field. Show size 0 bubbles or select a different Bubble size field.'
        )}
        buttonLabel={t(
          i18nLocale,
          'tabview:graphViews.emptyState.onlyZeroValuesInBubbleSize.showSizeZeroBubbles',
          'Show size 0 bubbles'
        )}
        onButtonClick={onShowSizeZeroBubbles}
        extraButton={
          <SecondaryButton onClick={onChangeBubbleSizeField}>
            {t(
              i18nLocale,
              'tabview:graphViews.emptyState.onlyZeroValuesInBubbleSize.changeBubbleSizeField',
              'Change bubble size field'
            )}
          </SecondaryButton>
        }
      />
    </EmptyStatesDoqContainer>
  );
};

export const OnlyZeroValuesInBubbleSizeFieldDoq = connect(
  OnlyZeroValuesInBubbleSizeFieldDoqBase,
  i18nLocale$.pipe(map(i18nLocale => ({ i18nLocale })))
);
